/** The platform's base domain (prod citybus.com.np); undefined in dev. Kept apart so Jest can stub it (no import.meta there). */
export const BASE_DOMAIN = import.meta.env.VITE_BASE_DOMAIN as string | undefined
